export default "__VITE_ASSET__af64dfa7__"